import type { PriceType } from '@/domain/entities/price-type.entity'
import type { PriceTypeDto } from './price-type.dto'

export const priceTypeMapper = {
  toPriceType(dto: PriceTypeDto): PriceType {
    return {
      id: dto.id,
      tenantId: dto.tenant_id,
      name: dto.name,
      createdAt: dto.created_at,
      updatedAt: dto.updated_at,
    }
  },
}
